const featuresPay = {
    featureTitle: 'Tome Decisões de Negócios Baseadas em Dados',
    featureDescription:
        'Saiba quais itens estão vendendo e gerando mais lucro, e acesse relatórios financeiros a qualquer hora, em qualquer lugar. Seu negócio na palma da sua mão!',
    featureButton: "Assinatura Premium",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: 'A partir de',
    featureEndingText: 'Mil',

    features: [
        {
            title: 'Itens Ilimitados',
            description: 'Adicione todos os itens que possui sem nenhum limite.'
        },
        {
            title: 'Equipe Ilimitada',
            description: 'Adicione Funcionários/Administradores ao negócio sem nenhum limite.'
        },
        {
            title: 'Histórico Ilimitado',
            description: 'Visualize alterações em registros de estoque antigos sem nenhum limite.'
        },
        {
            title: 'Filtro de Histórico',
            description: 'Visualize facilmente o histórico com base em tipo, categoria, funcionário e data.'
        },
        {
            title: 'Download para Excel',
            description: 'Obtenha o histórico de registros de estoque no Microsoft Excel com um único clique.'
        },
        {
            title: 'Download para PDF',
            description: 'Obtenha a lista mais recente de itens e estoque em PDF com um único clique.'
        }
    ],
    warehousesGuide: [
        {
            desc: 'Crie múltiplos armazéns para uma melhor gestão de estoque.'
        },
        {
            desc: 'Atribua produtos a locais específicos.'
        },
        {
            desc: 'Monitore os níveis de inventário em todos os armazéns.'
        }
    ],
    addVariantsGuide: [
        { desc: 'Adicione variantes de tamanho, cor ou material.' },
        { desc: 'Defina níveis de estoque por variante.' },
        { desc: 'Acompanhe em todos os armazéns.' }
    ]
}

export default featuresPay
